{
  "version": 1,
  "asset_id": "faa971d3-b89c-4cba-9a2d-6d6c06a0be8b",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/faa971d3-b89c-4cba-9a2d-6d6c06a0be8b/clip-img_2346-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/faa971d3-b89c-4cba-9a2d-6d6c06a0be8b/clip-img_2346-poster-sm.webp",
  "original_filename": "clip-img_2346-poster-sm.webp",
  "size": 11278,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:50Z"
}
